// nnkitodo [v2later] chelou

export class ModalActions {
  static actionNavigation = 'ACTION_NAVIGATION';
}
